export default class WidgetManager {
  constructor() {
    this.isReady = false;

    this.initLazyScripts = this.initLazyScripts.bind(this);
    this.removeListeners = this.removeListeners.bind(this);
  }

  install() {
    document.addEventListener('mousedown', this.initLazyScripts);
    document.addEventListener('mousemove', this.initLazyScripts);
    document.addEventListener('touchstart', this.initLazyScripts);
    document.addEventListener('keydown', this.initLazyScripts);
    document.addEventListener('scroll', this.initLazyScripts);
  }

  removeListeners() {
    document.removeEventListener('mousedown', this.initLazyScripts);
    document.removeEventListener('mousemove', this.initLazyScripts);
    document.removeEventListener('touchstart', this.initLazyScripts);
    document.removeEventListener('keydown', this.initLazyScripts);
    document.removeEventListener('scroll', this.initLazyScripts);
  }

  initLazyScripts() {
    if (this.isReady) {
      return;
    }

    const noScriptEls = document.querySelectorAll('.lazy-script');
    noScriptEls.forEach((el) => {
      let scriptEl = document.createElement('script');
      scriptEl.innerHTML = el.innerHTML;
      el.parentNode.replaceChild(scriptEl, el);
    });

    this.isReady = true;
    this.removeListeners();
  }
}
